import * as React from 'react'
import { useOnClickOutside } from 'usehooks-ts'

import { useReject } from './hooks'
import { setReject, submitReject } from './model'
import {
  CButton,
  CForm,
  CFormFeedback,
  CFormInput,
  CInputGroup,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { cardVerificationStatus } from '../../const'

type Props = {
  requestId: string
  status: string
  className?: string
  color?: string
}

export const RejectModal = ({ requestId, status, className, color }: Props) => {
  const { reject, isLoading } = useReject()
  const [isVisible, setVisible] = React.useState(false)
  const ref = React.useRef(null)

  useOnClickOutside(ref, () => {
    if (isVisible) {
      setReject({ comment: '' })
    }
    setVisible(false)
  })
  return (
    <>
      {status !==
        cardVerificationStatus.cardVerificationRequestStatusRejected() && (
        <CButton
          color={color}
          className={className}
          onClick={() => setVisible(true)}
        >
          Reject
        </CButton>
      )}
      <CModal visible={isVisible} onClose={() => setVisible(false)}>
        <CForm
          className="row g-3 needs-validation"
          noValidate
          onSubmit={(e) => {
            e.preventDefault()
            submitReject({
              requestId,
              status:
                cardVerificationStatus.cardVerificationRequestStatusRejected(),
              comment: reject.comment,
            })
            setVisible(false)
          }}
          id="rejectForm"
        >
          <CModalHeader>
            <CModalTitle>Set comment</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p>
              "The copy must contain the first 6 digits and the last 4 digits of
              the card number, cardholder's name, expiry date and cardholder's
              signature. Please make a new request and attach the card."
            </p>
            <p>
              For send standard rejection comment please paste
              "info.payment-reject-reason-card" in input below
            </p>
            <CInputGroup className="mb-3">
              <CFormInput
                placeholder="comment"
                autoComplete="comment"
                name="comment"
                required
                value={reject.comment}
                onChange={(e) => {
                  setReject({
                    comment: e.target.value,
                  })
                }}
              />
              <CFormFeedback invalid>Field is required</CFormFeedback>
            </CInputGroup>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cancel
            </CButton>
            <CButton
              color="primary"
              className="px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Reject
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
